import { render, staticRenderFns } from "./cadnotasfornecedores.vue?vue&type=template&id=5551eb14&"
import script from "./cadnotasfornecedores.vue?vue&type=script&lang=js&"
export * from "./cadnotasfornecedores.vue?vue&type=script&lang=js&"
import style0 from "./cadnotasfornecedores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports